import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../firebase';
import { onAuthStateChanged } from 'firebase/auth';

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [permissions, setPermissions] = useState({
    canRead: false,
    canUpdate: false,
    canDelete: false,
    displayName: null,
  });
  const [isLoading, setIsLoading] = useState(true);

  // ✅ Listen for auth state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        console.log('✅ User logged in:', currentUser.email);
        setUser(currentUser);

        try {
          // Get custom claims to check admin role
          const idTokenResult = await currentUser.getIdTokenResult();
          const customClaims = idTokenResult.claims;
          
          console.log('🔍 Custom claims:', customClaims);

          // ✅ Check for admin or super_admin role
          const isAdminUser = customClaims.admin === true || customClaims.super_admin === true;
          console.log('✅ Is Admin?', isAdminUser);
          console.log('📋 Admin claim value:', customClaims.admin);

          setIsAdmin(isAdminUser);

          // Set permissions based on role
          if (isAdminUser) {
            setPermissions({
              canRead: true,
              canUpdate: true,
              canDelete: true,
              displayName: currentUser.displayName || currentUser.email,
            });
            console.log('✅ Admin permissions granted');
          } else {
            console.log('⚠️ User does not have admin role');
            setPermissions({
              canRead: false,
              canUpdate: false,
              canDelete: false,
              displayName: currentUser.displayName || currentUser.email,
            });
          }
        } catch (error) {
          console.error('❌ Error getting user claims:', error);
          setIsAdmin(false);
          setPermissions({
            canRead: false,
            canUpdate: false,
            canDelete: false,
            displayName: currentUser.displayName || currentUser.email,
          });
        }
      } else {
        console.log('❌ User logged out');
        setUser(null);
        setIsAdmin(false);
        setPermissions({
          canRead: false,
          canUpdate: false,
          canDelete: false,
          displayName: null,
        });
      }
      setIsLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const value = {
    user,
    setUser,
    isAdmin,
    setIsAdmin,
    permissions,
    setPermissions,
    isLoading,
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};